import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Provider } from '@angular/core';
import { ProductBasedRedirectAnchorInterceptorService } from '@platform-frontend/checkout';
import { Observable } from 'rxjs';
import { UrlBasedRedirectAnchorInterceptorService } from './iframe/url-based-redirect-anchor-interceptor.service';
import { WebCheckoutIntegrationService } from './web-checkout-integration.service';

@Injectable()
export class WebCheckoutRedirectAnchorInterceptor implements HttpInterceptor {
  constructor(
    private productBasedRedirectAnchorInterceptorService: ProductBasedRedirectAnchorInterceptorService,
    private urlBasedRedirectAnchorInterceptorService: UrlBasedRedirectAnchorInterceptorService,
    private webCheckoutIntegrationService: WebCheckoutIntegrationService
  ) {}

  static getProvider(): Provider {
    return {
      provide: HTTP_INTERCEPTORS,
      useClass: WebCheckoutRedirectAnchorInterceptor,
      multi: true
    };
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.webCheckoutIntegrationService.getIntegrationMode() === 'iframe'
      ? this.urlBasedRedirectAnchorInterceptorService.intercept(request, next)
      : this.productBasedRedirectAnchorInterceptorService.intercept(request, next, 'standalone');
  }
}
